import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';
import FormDataContext from 'integrations/contexts/FormDataContext';

import { Input } from 'components/bootstrap';

import type { HandleFieldUpdateType, AdvancedOptionsContextType, HandleSqsBatchSizeType } from '../common/utils/types';
import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';

interface Props {
  onChange: HandleFieldUpdateType;
  handleSqsMessageBatchSizeChange: HandleSqsBatchSizeType;
}

const FormAdvancedOptions = ({ onChange, handleSqsMessageBatchSizeChange }: Props) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { genericS3ThrottleEnabled, overrideSource, sqsMessageBatchSize } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  const internalHandleSqsBatchSizeChange = (e) => {
    const { value } = e.target;
    onChange(e, formData);

    if (value >= 1 && value <= 10) {
      handleSqsMessageBatchSizeChange('');
    } else {
      handleSqsMessageBatchSizeChange('Please select SQS Message Batch Size between 1 - 10.');
    }
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox
        id="genericS3ThrottleEnabled"
        defaultChecked={genericS3ThrottleEnabled?.value}
        onChange={onChange}
      />
      <Input
        id="overrideSource"
        type="text"
        value={overrideSource?.value}
        onChange={onChange}
        label="Override Source (optional)"
        help="The source is set to the S3 bucket name by default. Set this if you want to override it with a custom value."
      />
      <Input
        id="sqsMessageBatchSize"
        type="number"
        min="1"
        value={sqsMessageBatchSize?.value}
        onChange={internalHandleSqsBatchSizeChange}
        label="SQS Message Batch Size"
        help="The maximum number of messages to query from SQS at a time. The maximum acceptable value is 10."
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
